export default __webpack_public_path__ + "static/media/icon_bookmark.048c8c4f.svg";